import { type Country } from '@module/mdrt-org/shared/utils/types/countries';
import { type SelectOption } from '@shared/utils/types/select-option';

export const buildPhoneIsoCodeOptions = (countriesData: Country[]): Array<SelectOption<string>> => {
  const groupedOptions: Record<string, Country[]> = {};

  for (const country of countriesData) {
    (groupedOptions[country.telephoneCode] = groupedOptions[country.telephoneCode] || []).push(
      country
    );
  }

  const getCombinedCountryIsoCodes = (countryList: Country[]) =>
    countryList.map((country) => country.isoCode).join(' / ');

  return Object.values(groupedOptions)?.map((countryList) => ({
    label: `+${countryList[0].telephoneCode} ${getCombinedCountryIsoCodes(countryList)}`,
    value: countryList[0].telephoneCode,
  }));
};
